<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <Breadcrumbs
        headline="Chi tiết tuyến đi"
        :link="[
          { text: 'Báo cáo xe tuyến', href: '/busCheckin' },
          { text: 'Chi tiết tuyến đi', href: '' }
        ]"
      />
    </div>

    <v-card outlined class="pa-4 mx-4">
      <v-row>
        <v-col cols="12" md="4">
          <div>
            <div class="text-h6">
              Tuyến xe
            </div>
            <div>
              {{ $_get(busCheckin, 'bus.name') }}
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="4">
          <div>
            <div class="text-h6">
              Chiều di chuyển
            </div>
            <div>
              {{ (busCheckin.bus_schedule || {}) | getBusTimeline }}
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="4">
          <div>
            <div class="text-h6">
              Ngày
            </div>
            <div>
              {{ busCheckin.createdAt | ddmmyyyy }}
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card>

    <v-card class="ma-4">
      <v-data-table
        :headers="headers"
        mobile-breakpoint="0"
        :items="busStudentTrackings"
        item-key="id"
        :loading="loading"
        loading-text="Đang Tải"
        no-data-text="Không có dữ liệu"
        disable-sort
      >
        <template v-slot:[`item.student`]="{ item }">
          <CardStudentName :student="item.student" link />
        </template>
        <template v-slot:[`item.timeCheckIn`]="{ item }">
          {{ item.timeCheckIn | getTimeFromTimestampt }}
        </template>
        <template v-slot:[`item.timeCheckOut`]="{ item }">
          {{ item.timeCheckOut | getTimeFromTimestampt }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <div v-if="$_get(item, 'status')">
            <v-chip small style="margin: 0" class="white--text" :color="item.status | getAttendanceStatusColor" label>
              {{ item.status | getBusStudentAttendanceStatus }}
            </v-chip>
          </div>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'

export default {
  components: {
    Breadcrumbs,
    CardStudentName
  },
  data() {
    return {
      headers: [
        { text: 'Học sinh', value: 'student', width: 150 },
        { text: 'Giờ lên xe', value: 'timeCheckIn', width: 100, align: 'center' },
        { text: 'Giờ xuống xe', value: 'timeCheckOut', width: 100, align: 'center' },
        { text: 'Trạng thái', value: 'status', width: 100 }
      ]
    }
  },
  computed: {
    ...mapGetters({
      busStudentTrackings: 'BusCheckin/busStudentTrackings',
      busCheckin: 'BusCheckin/busCheckin',
      loading: 'BusCheckin/loading'
    })
  },
  methods: {
    ...mapActions('BusCheckin', ['setDate', 'getBusStudentTracking', 'findOne']),
    ...mapMutations({
      resetData: 'BusCheckin/resetData'
    })
  },
  async created() {
    this.resetData()
    const busTrackingId = this.$route.params.busCheckInId
    await this.getBusStudentTracking({ bus_tracking: busTrackingId })
    await this.findOne(busTrackingId)
  }
}
</script>
